import { convertHexToRgbA } from '../utils';

const COLOR_SCHEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	LIGHT: 'light',
	DARK: 'dark',
	NEUTRAL: 'neutral',
	GHOST: 'ghost'
};

export const COLOR_SCHEME_STATES = {
	[COLOR_SCHEME.PRIMARY]: {
		normal: {
			backgroundColor: '#FDD437'
		},
		hover: {
			backgroundColor: '#FFCA00'
		},
		active: {
			backgroundColor: '#D8AB00'
		},
		disabled: {
			backgroundColor: '#343435'
		}
	},
	[COLOR_SCHEME.LIGHT]: {
		normal: {
			backgroundColor: '#ffffff'
		},
		hover: {
			backgroundColor: '#E5E5E5'
		},
		active: {
			backgroundColor: '#D9D9D9'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.DARK]: {
		normal: {
			backgroundColor: '#37332D'
		},
		hover: {
			backgroundColor: '#413D37'
		},
		active: {
			backgroundColor: '#413d37'
		},
		disabled: {
			backgroundColor: '#343435'
		}
	},
	[COLOR_SCHEME.NEUTRAL]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	},
	[COLOR_SCHEME.GHOST]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	}
};
